function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Debug from './Debug';
import validationSchema from '../validation-schema';

var Wizard = /*#__PURE__*/function (_React$Component) {
  _inherits(Wizard, _React$Component);

  var _super = _createSuper(Wizard);

  function Wizard(props) {
    var _this;

    _classCallCheck(this, Wizard);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "next", function (values) {
      return _this.setState(function (state) {
        return {
          page: Math.min(state.page + 1, _this.props.children.length - 1),
          values: values
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "previous", function () {
      return _this.setState(function (state) {
        return {
          page: Math.max(state.page - 1, 0)
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "transformErrors", function (schemaErr) {
      return schemaErr.inner.reduce(function (acc, err) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, err.path, err.message));
      }, {});
    });

    _defineProperty(_assertThisInitialized(_this), "validate", function (values) {
      var _this$props = _this.props,
          children = _this$props.children,
          requiredFields = _this$props.requiredFields;
      var page = _this.state.page;
      var activePage = React.Children.toArray(children)[page];
      if (activePage.props.agreements) return activePage.props.validate(values);

      try {
        validationSchema.validateSync(values, {
          context: {
            requiredFields: requiredFields
          },
          abortEarly: false
        });
        return {};
      } catch (err) {
        return _this.transformErrors(err);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (values, bag) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          onSubmit = _this$props2.onSubmit;
      var page = _this.state.page;
      var isLastPage = page === React.Children.count(children) - 1;

      if (isLastPage) {
        return onSubmit(values, bag);
      }

      _this.next(values);

      bag.setTouched({});
      bag.setSubmitting(false);
    });

    _this.state = {
      page: 0,
      values: props.initialValues
    };
    return _this;
  }

  _createClass(Wizard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          withDebug = _this$props3.withDebug;
      var _this$state = this.state,
          page = _this$state.page,
          values = _this$state.values;
      var activePage = React.Children.toArray(children)[page];
      var isLastPage = page === React.Children.count(children) - 1;
      return /*#__PURE__*/React.createElement(Formik, {
        initialValues: values,
        enableReinitialize: false,
        validate: this.validate,
        onSubmit: this.handleSubmit,
        render: function render(_ref) {
          var handleSubmit = _ref.handleSubmit;
          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit
          }, isLastPage ? /*#__PURE__*/React.cloneElement(activePage, {
            onPrevious: _this2.previous
          }) : activePage, withDebug && /*#__PURE__*/React.createElement(Debug, null));
        }
      });
    }
  }]);

  return Wizard;
}(React.Component);

Wizard.displayName = "Wizard";

_defineProperty(Wizard, "Page", function (_ref2) {
  var children = _ref2.children;
  return children;
});

Wizard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  initialValues: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  withDebug: PropTypes.bool,
  requiredFields: PropTypes.array
};
Wizard.defaultProps = {
  withDebug: false
};
export default Wizard;